export const configKey_UserTypes = 'user-types';
//# sourceMappingURL=user-types.js.map